import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-sellable-type-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(SellableTypeMultiSelectSearchControlComponent)
    ]
})
export class SellableTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.sellable-type.compProduct", value: "Composite Product"},
            {label: "wbo.bi.search.option.sellable-type.product", value: "Product"},
            {label: "wbo.bi.search.option.sellable-type.extra", value: "Extra"}
        ]);
    }
}
